/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <polygon
          points="12.63 7.98 7.03 2.61 1.36 8 0 6.69 7.04 0 14 6.68 12.63 7.98"
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'DrawerCaretFlippedIcon';

export default Icon;
